import {RemoteFacialBiometricConsult} from 'data/usecases/others/facial-biometric';
import {PostFacialBiometricConsult} from 'domain/usecases/others/facial-biometric';
import {makeAuthorizeHttpClientDecorator} from 'main/factories/decorators';
import {makeBFFApiUrl} from 'main/factories/http';
import {FacialBiometricEndpoints} from '../../endpoints';

export const makeFacialBiometricConsult = (): PostFacialBiometricConsult =>
	new RemoteFacialBiometricConsult(
		makeBFFApiUrl(FacialBiometricEndpoints.consult),
		makeAuthorizeHttpClientDecorator(),
	);
